// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      test_name: string,
      external_id: string,
      email: string,
    })
  ),
});
